import extend from 'lodash/extend';
import MapboxDraw from '@mapbox/mapbox-gl-draw';

export const SimpleSelect = extend(MapboxDraw.modes.simple_select, {
  dragMove() {}
});

export const DirectSelect = extend(MapboxDraw.modes.direct_select, {
  dragFeature() {}
});